// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@flip/App/Components/Common/XngZone";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

export interface MyAccountHistoryPagesLayoutStyles {
    container?: InjectableCss;
    titleContainer?: InjectableCss;
    extraWidgetContainer?: InjectableCss;
    filterResultContainer?: InjectableCss;
    tagsContainer?: InjectableCss;
    topPaginationContainer?: InjectableCss;
    tableContainer?: InjectableCss;
    bottomPaginationContainer?: InjectableCss;
}

export const myAccountHistoryPagesLayoutStyles: MyAccountHistoryPagesLayoutStyles = {
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 24px;
        `,
    },
    extraWidgetContainer: {
        css: css`
            &:empty,
            &:has(> div:empty) {
                display: none;
            }
        `,
    },
    filterResultContainer: {
        css: css`
            &:empty,
            &:has(> div:empty) {
                display: none;
            }
        `,
    },
    tagsContainer: {
        css: css`
            &:empty,
            &:has(> div:empty) {
                display: none;
            }
        `,
    },
    topPaginationContainer: {
        css: css`
            &:empty,
            &:has(> div:empty) {
                display: none;
            }
        `,
    },
    tableContainer: {
        css: css`
            margin-top: 8px;

            &:empty,
            &:has(> div:empty) {
                display: none;
            }
        `,
    },
    bottomPaginationContainer: {
        css: css`
            margin-top: 8px;

            &:empty,
            &:has(> div:empty) {
                display: none;
            }
        `,
    },
};

const styles = myAccountHistoryPagesLayoutStyles;
const MyAccountDetailsPagesLayout: FC<WidgetProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="My-Account-History-Pages-Layout">
            <StyledWrapper {...styles.titleContainer}>
                <XngZone contentId={id} zoneName="Content01" hint="Zone For Title" />
            </StyledWrapper>
            <StyledWrapper {...styles.extraWidgetContainer}>
                <XngZone contentId={id} zoneName="Content02" hint="Zone For Extra Widgets" />
            </StyledWrapper>
            <StyledWrapper {...styles.filterResultContainer}>
                <XngZone contentId={id} zoneName="Content03" hint="Zone For Filter Results" />
            </StyledWrapper>
            <StyledWrapper {...styles.tagsContainer}>
                <XngZone contentId={id} zoneName="Content04" hint="Zone For Tags" />
            </StyledWrapper>
            <StyledWrapper {...styles.tableContainer}>
                <XngZone contentId={id} zoneName="Content05" hint="Zone For Table" />
            </StyledWrapper>
            <StyledWrapper {...styles.bottomPaginationContainer}>
                <XngZone contentId={id} zoneName="Content06" hint="Zone For Bottom Pagination" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: MyAccountDetailsPagesLayout,
    definition: {
        group: "Layout" as any,
        displayName: "My Account History Pages Layout",
        allowedContexts: [
            "OrderHistoryPage",
            "VmiOrderHistoryPage",
            "SavedOrderListPage",
            "OrderApprovalListPage",
            "RfqMyQuotesPage",
        ],
    },
};

export default widgetModule;
